import React from 'react'
import GalleryReadPageComponent from './GalleryReadPageComponent'

const GalleryReadPage = () => {
  return (
    <div>
      <GalleryReadPageComponent/>
    </div>
  )
}

export default GalleryReadPage
